import dart from "../assets/icons/dart_icon.png"
import flutter from "../assets/icons/flutter_icon.png"
import figma from "../assets/icons/figma_icon.png"
import react from "../assets/icons/react_icon.png"
import tailwind from "../assets/icons/tailwind_icon.png"


export const project_desk = [
  {
    position: { top: 237, right: 212 },
  },
  {
    position: { top: 130, right: 132 },
  },
  {
    position: { top: 400, right: 138 },
  },
  {
    position: { top: 518, right: 103 },
  },
];

export const desktopIcons = [
  {
    id: "about-me",
    name: "About Me",
    type: "document",
    position: { top: 455, left: 105 },
  },
  {
    id: "trash",
    name: "Trash",
    type: "trash",
    position: { bottom: 55, right: 55 },
  },
  {
    id: "resume",
    name: "Resume",
    type: "document",
    position: { top: 565, left: 271 },
  },
];

export const dockApps = [
  { name: "Finder", img: "https://framerusercontent.com/images/wtQkw1jK0MlEDOrW0Q1kE5PBqc.png" },
  { name: "Launchpad", img: "https://framerusercontent.com/images/KCaz69s4OvhKMUI25E1RBeuNIyA.png" },
  { name: "Safari", img: "https://framerusercontent.com/images/qQISGOSSnz748TdrZn91l44R5u0.png" },
  { name: "Messages", img: "https://framerusercontent.com/images/fm90fwzWoBMCvK5C0MOyKdo94.png" },
  { name: "Mail", img: "https://framerusercontent.com/images/CwKoPLck9kD8CifRkrpug3socM.png" },
  { name: "Maps", img: "https://framerusercontent.com/images/YtLyrfz2kFN2QhkzBWG6TrATw.png" },
  { name: "Photos", img: "https://framerusercontent.com/images/ogWIDEJmWxA8SVRZpEe7gk35FcM.png?width=188&height=188" },
  { name: "FaceTime", img: "https://framerusercontent.com/images/xxKf6tPzYecSWOavDJjUB0MtXw.png?width=188&height=188" },
  { name: "Calendar", img: "https://framerusercontent.com/images/VeljykK560qBRDkQkYyhx8ChI.png?width=188&height=188" },
  { name: "Contacts", img: "https://framerusercontent.com/images/gi6dMq8dbjba0LyjZSuySu4X6zg.png?width=188&height=188" },
  { name: "Reminders", img: "https://framerusercontent.com/images/NMuItXJj2OKiPiAC2EdivhRPYY.png?width=188&height=188" },
  { name: "Notes", img: "https://framerusercontent.com/images/Z0d1XNe7wVINUiHydSL6noKho.png?width=188&height=188" },
  { name: "TV", img: "https://framerusercontent.com/images/1pORyCnfgAxpXWyCa1l7s8IJeK0.png?width=188&height=188" },
  { name: "Music", img: "https://framerusercontent.com/images/pjjxP6KY1Ttnqhuqt9oF3QBfmE.png?width=188&height=188" },
  { name: "Podcasts", img: "https://framerusercontent.com/images/y6Unx5f6vZ4SwFJ4bnDpnejmKM.png?width=188&height=188" },
  { name: "App Store", img: "https://framerusercontent.com/images/mjYHu1WKSujuvzAuskfVJSx2w.png?width=188&height=188" },
  { name: "System Preferences", img: "https://framerusercontent.com/images/VbY44vBZlQp4srNQK6ohxpco.png?width=188&height=188" },
];

export const stickyNotes = [
  {
    id: "sticky-about",
    title: "About Me",
    content: "Hi, I'm Inika! A product designer who loves crafting meaningful digital experiences. Currently exploring the intersection of design and technology.",
    color: "#FFFACD",
    position: { bottom: 248, left: 804 },
    size: { width: "auto", height: 152 },
  },
];

export const menuBarItems = {
  left: [
    // { label: "Badusha's Portfolio", bold: true, href: "/" },
    { label: "About Me", href: "#about-me" },
    { label: "Projects", href: "#projects" },
    { label: "Resume", href: "https://badushapareed.in/resume.pdf" },
    { label: "Contact", href: "mailto:hi.badushapareed@gmail.com" },
  ],
};

export const projectIcons = {
  "figma": figma,
  "flutter": flutter,
  "react": react,
  "tailwind": tailwind,
  "dart": dart,
}